import { Route } from 'react-router-dom';

/** Registers the same page at root and under /s/:orgSlug/:storeSlug */
export function dualStoreRoute(path, element, key) {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return [
        <Route key={`${key}-root`} path={normalized} element={element} />,
        <Route key={`${key}-store`} path={`/s/:orgSlug/:storeSlug${normalized}`} element={element} />,
    ];
}
